export default function ({ $axios, app, redirect }) {
  $axios.onError((error) => {
    const code = parseInt(error.response?.status);
    if (code === 401) {
      if (
        error.request &&
        !error.request.responseURL.endsWith('user.php') &&
        error.response.data.authentication_required
      ) {
        if (app.$auth.loggedIn) {
          app.$auth
            .logout()
            .then((res) => {})
            .catch(() => {});
        }
        return Promise.resolve(false);
      }
    }
  });
}
